import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid.tsx';
import { PdpSharedSimilarSoldItemsHeader } from '../PdpSharedSimilarSoldItems/PdpSharedSimilarSoldItemsHeader.tsx';
import { PdpRespSimilarSoldItemsGradient } from './PdpRespSimilarSoldItems.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import styles from './PdpRespSimilarSoldItemsLoading.scss';
import { type PdpRespSimilarSoldItemsLoading_item$key } from './__generated__/PdpRespSimilarSoldItemsLoading_item.graphql.ts';

const itemFragment = graphql`
    fragment PdpRespSimilarSoldItemsLoading_item on Item {
        ...PdpSharedSimilarSoldItemsHeader_item
    }
`;

const PdpRespSimilarSoldItemsLoading: FC<{ item: PdpRespSimilarSoldItemsLoading_item$key }> = ({
    item: itemRef,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const columns = [...new Array(4)].map((_, columnIndex) => (
        <div key={`column-${columnIndex}`}>
            <div
                className={classnames(
                    styles.shimmer,
                    styles.similarItemColumnWidth,
                    styles.similarItemImageHeight,
                    dibsCss.mXsmall,
                    dibsCss.mbMedium,
                    dibsCss.roundedXxsmall
                )}
            />
            {[...new Array(3)].map((__, fieldIndex) => (
                <div
                    key={`field-${fieldIndex}`}
                    className={classnames(
                        styles.shimmer,
                        styles.similarItemColumnWidth,
                        styles.similarItemDataFieldHeight,
                        dibsCss.mxXsmall,
                        dibsCss.mtXsmall,
                        dibsCss.roundedXxsmall
                    )}
                />
            ))}
        </div>
    ));

    return (
        <GridRow>
            <GridCol desktop={12} tabletPortrait={12} tabletLandscape={12}>
                <div
                    className={classnames(
                        dibsCss.sassyFontBodyMediumHeavy,
                        dibsCss.textNoir,
                        dibsCss.mtMedium
                    )}
                >
                    <PdpSharedSimilarSoldItemsHeader item={item} />
                </div>
                <div
                    className={classnames(
                        dibsCss.relative,
                        dibsCss.flex,
                        dibsCss.ptXsmall,
                        dibsCss.overflowHidden,
                        dibsCss.h300px
                    )}
                >
                    <div
                        className={classnames(
                            styles.shimmer,
                            styles.currentItemColumnWidth,
                            dibsCss.prXsmall,
                            dibsCss.h300px,
                            dibsCss.roundedXxsmall
                        )}
                    />
                    {columns}
                    <PdpRespSimilarSoldItemsGradient />
                </div>
                <div
                    className={classnames(
                        styles.shimmer,
                        styles.expandButton,
                        dibsCss.roundedXxsmall
                    )}
                />
            </GridCol>
        </GridRow>
    );
};

export default PdpRespSimilarSoldItemsLoading;
